interface Product {
  id: string;
  name: string;
  grade: string;
  category: string;
  icon: string;
  description: string;
  applications: string[];
  variants: string[];
}

interface ProductCardProps {
  product: Product;
  onSelect: (product: Product) => void;
}

export default function ProductCard({ product, onSelect }: ProductCardProps) {
  return (
    <div
      className="bg-white border border-stone-200 rounded-lg overflow-hidden hover:-translate-y-1 transition-transform duration-200 cursor-pointer flex flex-col"
      onClick={() => onSelect(product)}
    >
      {/* Header */}
      <div className="bg-emerald-700 px-5 py-4 flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-md shrink-0">
          <i className={`${product.icon} text-white text-lg`} />
        </div>
        <div className="min-w-0">
          <h3 className="text-white font-bold text-sm leading-tight">{product.name}</h3>
          <span className="text-emerald-200 text-xs mt-0.5 block">{product.category}</span>
        </div>
      </div>

      {/* Body */}
      <div className="px-5 py-4 flex flex-col flex-1">
        {/* Grade badge */}
        <div className="flex flex-wrap gap-1.5 mb-3">
          {product.variants.map((v) => (
            <span
              key={v}
              className="bg-emerald-50 text-emerald-700 text-xs font-semibold px-2 py-0.5 rounded-full border border-emerald-100"
            >
              {v}
            </span>
          ))}
        </div>

        <p className="text-gray-500 text-sm leading-relaxed flex-1 line-clamp-3">{product.description}</p>

        {/* Applications */}
        <div className="mt-4 pt-4 border-t border-stone-100">
          <p className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-2">Applications</p>
          <ul className="flex flex-col gap-1">
            {product.applications.map((app) => (
              <li key={app} className="flex items-center gap-2 text-xs text-gray-500">
                <i className="ri-checkbox-circle-line text-emerald-500 shrink-0" />
                {app}
              </li>
            ))}
          </ul>
        </div>

        <button
          className="mt-4 w-full text-center text-emerald-700 border border-emerald-200 hover:bg-emerald-50 text-xs font-semibold py-2 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          onClick={(e) => { e.stopPropagation(); onSelect(product); }}
        >
          View Details
        </button>
      </div>
    </div>
  );
}
